// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"83ed721b","253":"f4269492","382":"1908675e","437":"d08bd459","495":"f3b4eeaf","614":"923ad68c","665":"1b028355","713":"fe1dc3cd","765":"c2eae55b","814":"1abf5e60","838":"ce37e73c","852":"cc1cdbec","937":"0cd0f04c","949":"bd98e704"}[chunkId] + ".chunk.js";
};